export enum CashFtBundleIds {
    PLASTIC = 100,
    METAL = 101,
};